import { defineComponent as _defineComponent } from 'vue'
import { ComputedRef, computed } from "@nuxtjs/composition-api";

import { useI18n } from "@/composables";
import { useCreatorProductStore } from "@/store/creator-products";
import { Actions } from "@/utils/snowplow/enums";
import { createProductImpression } from "@/utils/snowplow/factory";


export default /*#__PURE__*/_defineComponent({
  __name: 'TrendingProductTile',
  props: {
  productId: { type: String, required: true },
  profileId: { type: String, required: true },
  position: { type: Number, required: false, default: null },
},
  setup(__props) {

const props = __props;



const i18n = useI18n();
const creatorProductStore = useCreatorProductStore();

const product = creatorProductStore.getProductById(props.productId);
const productImage = computed(() => product?.mediaObject?.mediaCdnUrl);
const productName = computed(() => product?.productDetail?.name);
const productUrl = computed(() => product?.linkUrl);
const productPrice = computed(() =>
  Intl.NumberFormat(i18n.locale, { style: "currency", currency: "USD" }).format(product?.productDetail?.price ?? 0),
); // the endpoint currently doesn't supply locale information, so format everything in USD

const amplitudePayload: ComputedRef<LtkProductProps> = computed(() => ({
  "ltk-id": product?.postId ?? "",
  "product-id": product?.productReferenceId ?? "",
  "advertiser-name": product?.retailerDisplayName ?? "",
  url: product?.linkUrl ?? "",
  index: props.position ?? "",
}));

const impressionPayload = computed(() =>
  createProductImpression(Actions.View, {
    product_id: props.productId,
    promotion_id: product?.postId ?? "",
    position: props.position,
    creator_id: props.profileId ?? "",
  }),
);

return { __sfc: true,props, i18n, creatorProductStore, product, productImage, productName, productUrl, productPrice, amplitudePayload, impressionPayload }
}

})